import React, { Fragment, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Loader from './layouts/layoutcomponents/Loader';
import "./index.scss"
import { RouterData } from './commondata/routingdata';
import App from './layouts/app';
import ErrorPages from './layouts/ErrorPages';
import Error400 from './components/Errorpages/Error400/Error400';
import Dashboard from './components/Dashboard/Dashboard';
import translations from './shared/translation/translation.json'

import {API_AUTH} from './shared/consts/api'
import { BASE_URL } from './shared/consts/baseUrl';


const AuthenticationPage = lazy(() => import('./layouts/authenticationpage'));

const SignIn = lazy(() => import('./components/SignIn/SignIn'));

const SignInPlatform = lazy(() => import('./components/SignIn/SignInPlatform'));

import { SettingProvider, TranslationItem } from '@np/np_webcomponentlib'
import DashboardBusiessMain from './pages/DashboardBusiness/DashboardBusiessMain';

//прокидываем api авторизации в контекст пакета
const setting = {
  auth: API_AUTH,
  media: '',
  language: "ru_RU",
  translationItems: translations as TranslationItem[],
  pathToAuthForm: "authentication/signinplatform/"
}

const container: HTMLElement | any = document.getElementById('root');
const root = createRoot(container);

const internalBalanceToken = import.meta.env.VITE_INTERNAL_BALANCE_TOKEN;

const balancePathsToWatch = ['/balance', '/operation/balance'];
const defaultOperationPayload = JSON.stringify({
  listFields: [],
  sort: null,
  searchData: '',
  take: 50,
  skip: 0,
});

const shouldInjectBalanceToken = (url: string): boolean => {
  if (!url) return false;
  return balancePathsToWatch.some(path => url.includes(path));
};

if (internalBalanceToken) {
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const requestUrl = typeof input === 'string'
      ? input
      : input instanceof Request
        ? input.url
        : `${input}`;

    const targetOperation = requestUrl.includes('/operation/list');

    const ensureOperationInit = (currentInit?: RequestInit): RequestInit => {
      if (!targetOperation) {
        return currentInit || {};
      }

      const headers = new Headers(currentInit?.headers ?? (input instanceof Request ? input.headers : undefined));
      if (!headers.get('Content-Type')?.includes('application/json')) {
        headers.set('Content-Type', 'application/json');
      }

      return {
        ...(currentInit || {}),
        headers,
        body: currentInit?.body ?? defaultOperationPayload,
      };
    };

    let modifiedInit = ensureOperationInit(init);

    if (shouldInjectBalanceToken(requestUrl)) {
      const headers = new Headers(modifiedInit.headers);

      if (!headers.has('Authorization')) {
        headers.set('Authorization', `Bearer ${internalBalanceToken}`);
      }

      modifiedInit = { ...modifiedInit, headers };
    }

    if (input instanceof Request) {
      return originalFetch(new Request(input, modifiedInit));
    }

    return originalFetch(input, modifiedInit);
  };

  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  const originalXHRSetRequestHeader = XMLHttpRequest.prototype.setRequestHeader;

  XMLHttpRequest.prototype.open = function (method: string, url: string, ...args: any[]) {
    (this as any)._interceptUrl = url;
    (this as any)._authorizationHeaderSet = false;
    return originalXHROpen.apply(this, [method, url, ...args]);
  };

  XMLHttpRequest.prototype.setRequestHeader = function (name: string, value: string) {
    if (name.toLowerCase() === 'authorization') {
      (this as any)._authorizationHeaderSet = true;
    }
    return originalXHRSetRequestHeader.apply(this, [name, value]);
  };

  XMLHttpRequest.prototype.send = function (...args: any[]) {
    if (!((this as any)._authorizationHeaderSet) && shouldInjectBalanceToken((this as any)._interceptUrl)) {
      originalXHRSetRequestHeader.call(this, 'Authorization', `Bearer ${internalBalanceToken}`);
      (this as any)._authorizationHeaderSet = true;
    }
    return originalXHRSend.apply(this, args);
  };
}

const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const token = localStorage.getItem('accessToken');
  if (!token) {
    return <Navigate to={`${BASE_URL}authentication/signinplatform`} replace />;
  }
  return children;
};

root.render(
  <Fragment>
    <SettingProvider value={setting}>
      <BrowserRouter>
        <React.Suspense fallback={<Loader />}>
          <Routes>
            <Route path={`${BASE_URL}`} element={<RequireAuth><App /></RequireAuth>}>



            <Route index element={<DashboardBusiessMain idBusinessProps={null} />} />
              {RouterData.map((idx) => (
              <Route path={idx.path} element={idx.element} key={Math.random()} />
              ))}
          </Route>

          {/* Authentication Pages */}
          <Route path={`${BASE_URL}authentication`} element={<AuthenticationPage />}>
              {/* <Route path="login" element={<Login />} /> */}
              <Route path="signin" element={<SignIn />} />
              <Route path="signinplatform" element={<SignInPlatform />} />
              {/* <Route path="register" element={<Register />} />
              <Route path="forgotpassword" element={<ForgotPassword />} />
              <Route path="lockscreen" element={<LockScreen />} /> */}
            </Route>

          <Route path={`${BASE_URL}listVal`} element={<Navigate to={`${BASE_URL}authentication/signin`} replace />} />
          <Route path={`${BASE_URL}listValplatform`} element={<Navigate to={`${BASE_URL}authentication/signinplatform`} replace />} />


            <Route path={`${BASE_URL}`} element={<ErrorPages />}>
            <Route path={`${BASE_URL}errorpages/error400`} element={<Error400 />} />
          </Route>
          </Routes>
        </React.Suspense>
      </BrowserRouter>
    </SettingProvider>
  </Fragment>
);
